export default function customEventPolyfill(document: Document, window: Window): Promise<any> {
    if (typeof (window as any).CustomEvent === "function") {
        return Promise.resolve();
    }
    return new Promise((resolve) => {
        // tslint:disable-next-line:no-console
        console.debug("Polyfill: Polyfilling CustomEvent...");

        function CustomEvent(event, params) {
            params = params || { bubbles: false, cancelable: false, detail: undefined };
            const evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }

        CustomEvent.prototype = (window as any).Event.prototype;

        (window as any).CustomEvent = CustomEvent;

        resolve();
    });
}



// WEBPACK FOOTER //
// ./polyfill/event/custom-event.polyfill.ts